@if (!loading && area) {
  <div class="page-container">
    <!-- Header Section -->

    <div class="page-navigation hero-header">
      <div class="member-area">
        @if (area.image) {
          <img
            class="image"
            [src]="headerBackgroundImage"
            alt="Bild des Mitgliederbereichs" />
        }
        <div class="details">
          <div class="title">Mitgliederbereich {{ area.name }}</div>
          <div class="role">
            <span class="role-chip">
              @switch (area.role) {
                @case ('OWNER') {
                  Eigentümer
                }
                @case ('ADMIN') {
                  Admin
                }
                @default {
                  Mitglied
                }
              }
            </span>
          </div>
          @if (area.description) {
            <div class="subtitle">
              {{ area.description }}
            </div>
          }
        </div>
        <div class="actions">
          @if (canContact) {
            <button
              class="inwi-text-button-medium-secondary contact-btn"
              (click)="onContactClick()">
              <div class="button-content">
                <i class="fa-regular fa-envelope button-icon"></i>
                <div class="button-text">Kontakt</div>
              </div>
            </button>
          }
          @if (canManage()) {
            <button
              class="inwi-icon-button-medium-primary edit-btn"
              (click)="openEditModal()"
              pTooltip="Bereich bearbeiten"
              tooltipPosition="bottom">
              <i class="fa-regular fa-pen"></i>
            </button>
          }
        </div>
      </div>
    </div>
    @if (canManage() && area.code) {
      <div class="area-code-container">
        <span class="code-label">Bereichs-Code:</span>
        <code class="area-code">{{ area.code }}</code>
        <button
          class="copy-code-btn"
          (click)="copyCodeToClipboard()"
          pTooltip="Code kopieren"
          tooltipPosition="right">
          <i class="fa-regular fa-copy"></i>
        </button>
      </div>
    }
    @if (!canManage() && !area.isPublic && adminMembers.length > 0) {
      <div class="admin-members-container">
        <span class="admin-member-label">Bereichs-Administratoren:</span>
        @for (admin of adminMembers; track admin.user_id) {
          <span class="admin-member-chip" data-role="ADMIN"
            >{{ admin.firstName }} {{ admin.lastName }}</span
          >
        }
      </div>
    }
    <!-- Content Container -->
    <div class="file-manager-container">
      <!-- Documents Section -->
      <section class="flex-c align-start gap-12 align-self-stretch">
        <div class="header">
          <h3 class="header-title">
            {{ reorderMode ? 'Reihenfolge bearbeiten' : 'Inhalte' }}
          </h3>
          <div class="header-actions">
            @if (canManage()) {
              <button
                [class.inwi-text-button-medium-secondary]="!reorderMode"
                [class.inwi-text-button-medium-primary]="reorderMode"
                (click)="toggleReorderMode()">
                <div class="button-content">
                  <i
                    class="fa-regular {{
                      reorderMode ? 'fa-floppy-disk' : 'fa-arrow-up-arrow-down'
                    }} button-icon"></i>
                  <div class="button-text">
                    {{
                      reorderMode
                        ? 'Reihenfolge übernehmen'
                        : 'Reihenfolge ändern'
                    }}
                  </div>
                </div>
              </button>
              @if (!reorderMode) {
                <button
                  class="inwi-text-button-medium-primary"
                  (click)="openContentUploadModal()">
                  <div class="button-content">
                    <i class="fa-regular fa-cloud-upload button-icon"></i>
                    <div class="button-text">Inhalte hinzufügen</div>
                  </div>
                </button>
              }
            }
          </div>
        </div>

        <div class="file-container">
          @if (filesLoading) {
            <div class="loading">Lade Dateien...</div>
          } @else if (!filesLoading && allContentItems.length === 0) {
            <div class="empty-state">Keine Inhalte vorhanden.</div>
          } @else {
            @if (reorderMode) {
              <p-orderList
                [value]="reorderContentItems"
                [dragdrop]="true"
                (onReorder)="onReorderContent()">
                <ng-template let-item pTemplate="item">
                  <div class="file-row">
                    <div class="position-circle">{{ item.position }}</div>
                    <i
                      class="fa-regular {{
                        item.kind === 'file'
                          ? getIconForFile(item.file!)
                          : getIconForLink()
                      }} fa-lg icon-spacing"></i>
                    <span class="title">{{ item.title }}</span>
                  </div>
                </ng-template>
              </p-orderList>
            } @else {
              <table class="file-list-view">
                <tbody>
                  @for (
                    item of allContentItems;
                    track item.id + '-' + item.kind
                  ) {
                    <tr
                      class="clickable-row"
                      tabindex="0"
                      (click)="onContentRowClick(item)"
                      (keydown.enter)="onContentRowClick(item)"
                      (keydown.space)="
                        onContentRowClick(item); $event.preventDefault()
                      ">
                      <td class="icon-col">
                        <i
                          class="fa-regular {{
                            item.kind === 'file'
                              ? getIconForFile(item.file!)
                              : getIconForLink()
                          }} fa-lg"></i>
                      </td>
                      <td
                        class="title-col"
                        [pTooltip]="item.title"
                        tooltipPosition="top">
                        {{ item.title }}
                      </td>
                      <td class="date-col">
                        {{
                          item.createdAt
                            ? (item.createdAt | date: 'dd.MM.yyyy')
                            : '-'
                        }}
                      </td>
                      @if (canManage()) {
                        <td class="actions-col">
                          <div class="action-buttons">
                            @if (item.kind === 'file') {
                              <button
                                class="inwi-icon-button-medium-secondary"
                                (click)="renameFile(item.file!, $event)"
                                pTooltip="Umbenennen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-pen"></i>
                              </button>
                              <button
                                class="inwi-icon-button-medium-secondary"
                                (click)="deleteFile(item.file!, $event)"
                                pTooltip="Löschen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            } @else {
                              <button
                                class="inwi-icon-button-medium-secondary"
                                (click)="deleteLink(item.link!, $event)"
                                pTooltip="Löschen"
                                tooltipPosition="top">
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            }
          }
        </div>
      </section>
    </div>

    <!-- Members Section -->
    @if (canManage() && !area.isPublic) {
      <div class="members-container">
        <section class="flex-c align-start gap-12 align-self-stretch">
          <div class="header">
            <h3 class="header-title">Mitglieder</h3>
            <div class="header-actions">
              <button
                class="inwi-text-button-medium-primary"
                (click)="openInviteModal()">
                <div class="button-content">
                  <i class="fa-regular fa-paper-plane button-icon"></i>
                  <div class="button-text">Mitglied einladen</div>
                </div>
              </button>
            </div>
          </div>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Rolle</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
                @for (m of memberships; track m.user_id) {
                  <tr>
                    <td data-label="Name">
                      {{
                        m.firstName || m.lastName
                          ? m.firstName + ' ' + m.lastName
                          : 'User #' + m.user_id
                      }}
                    </td>
                    <td>
                      <span class="role-chip" [attr.data-role]="m.role">
                        {{
                          m.role === 'OWNER'
                            ? 'Eigentümer'
                            : m.role === 'ADMIN'
                              ? 'Admin'
                              : 'Mitglied'
                        }}
                      </span>
                    </td>
                    <td data-label="Aktion">
                      <div class="member-actions">
                        <p-select
                          [disabled]="
                            m.role === 'OWNER' ||
                            m.user_id === userService.currentUser$.value?.id
                          "
                          (onChange)="updateRole(m, $event.value)"
                          [(ngModel)]="m.role"
                          [options]="roleOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Rolle auswählen...">
                        </p-select>
                        <button
                          class="delete-btn"
                          [disabled]="
                            m.role === 'OWNER' ||
                            m.user_id === userService.currentUser$.value?.id
                          "
                          (click)="removeMember(m, $event)"
                          pTooltip="Mitglied entfernen"
                          tooltipPosition="top">
                          <i class="fa-regular fa-user-xmark"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      </div>
    }
  </div>
}

@if (showUploadModal) {
  <div class="modal-overlay" (click)="closeUploadModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Inhalte hinzufügen</h3>
        <button class="close-btn" (click)="closeUploadModal()">
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <div class="modal-tabs">
        <button
          [class.active]="activeModalTab === 'file'"
          (click)="switchModalTab('file')">
          Datei
        </button>
        <button
          [class.active]="activeModalTab === 'link'"
          (click)="switchModalTab('link')">
          Link
        </button>
      </div>
      <div class="modal-body">
        <!-- FILE TAB -->
        @if (activeModalTab === 'file') {
          <div class="tab-content">
            <div class="upload-area">
              <input
                type="file"
                id="modalFileUpload"
                class="hidden-input"
                (change)="onFileSelected($event)"
                [disabled]="uploading" />
              <label for="modalFileUpload" class="upload-label">
                <i class="fa-regular fa-cloud-arrow-up"></i>
                <span>{{
                  uploading ? 'Wird hochgeladen...' : 'Datei auswählen'
                }}</span>
              </label>
            </div>
          </div>
        }
        <!-- LINK TAB -->
        @if (activeModalTab === 'link') {
          <div class="tab-content">
            <form
              [formGroup]="linkForm"
              (submit)="onSaveLink()"
              class="link-form">
              <input
                formControlName="title"
                placeholder="Titel des Links"
                class="inwi-input" />
              <input
                formControlName="url"
                placeholder="URL (https://...)"
                class="inwi-input" />
              <button
                class="inwi-text-button-medium-primary"
                type="submit"
                [disabled]="linkForm.invalid">
                <div class="button-content">
                  <i class="fa-regular fa-floppy-disk button-icon"></i>
                  <div class="button-text">Speichern</div>
                </div>
              </button>
            </form>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (showImagePreview) {
  <div class="modal-overlay" (click)="closeImagePreview()">
    <div class="image-preview-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ previewImageFileName }}</h3>
        <button class="close-btn" (click)="closeImagePreview()">
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <div class="image-preview-body">
        @if (previewImageUrl) {
          <img [src]="previewImageUrl" [alt]="previewImageFileName" />
        }
      </div>
    </div>
  </div>
}
